/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { PureComponent } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    object, arrayOf, shape, string, bool,
} from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { dateMMMMDDYYYY } from '../../utils/dateString';
import DesktopOrderListItem from './DesktopOrderListItem';
import { deepObjectExtend } from '../../utils/object';
import { combineStyle } from '../../style/combineStyle';
import { main as MainStyle } from '../../style/main';
import { DesktopOrderListStyle } from '../../style/DesktopOrderListStyle';

const styles = ({ typography, palette }) => deepObjectExtend(
    combineStyle(typography, palette, {
        MainStyle,
        DesktopOrderListStyle,
    }),
);

class DesktopOrderList extends PureComponent {
    render() {
        const {
            classes,
            order: {
                orderNumber, intOrderNumber, items, parentOrderNumber, uuid,
            },
            userProfile,
            brand,
        } = this.props;
        // There is a discrepancy of Order Details' API response between login and guest account.
        let { order: { orderPlaceddate: orderDate } } = this.props;
        if (!orderDate) {
            [{ orderDate }] = items;
        }
        const orderDateString = dateMMMMDDYYYY(orderDate);
        const hasOrderSpecific = orderNumber?.includes('3410286682');
        return (
            <div className={classes.DesktopOrderListStyle}>
                {brand.code !== '08F' && brand.code !== 'CAN'
                    ? (
                        <Grid container>
                            <Grid item xs={12}>
                                <Grid key={intOrderNumber} className={`${classes.orderProductMain} order-list-wrapper`}>
                                    <Grid className="orderHeader" container>
                                        <Grid className="orderHeaderItem" item xs={3}>
                                            <span className="headerItemLabel">Order #: </span>
                                            <span>{orderNumber}</span>
                                        </Grid>
                                        {parentOrderNumber
                                            ? (
                                                <Grid className="orderHeaderItem align-center" item xs={5}>
                                                    <span className="headerItemLabel">Replacement For: </span>
                                                    <span className="partOrderNumber">{parentOrderNumber}</span>
                                                </Grid>
                                            )
                                            : <Grid className="orderHeaderItem" item xs={5} />}
                                        <Grid className="orderHeaderItem" item xs={4}>
                                            <span className="headerItemLabel">Order Date: </span>
                                            <span className="orderDate">{orderDateString}</span>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        {
                                            items.map((data, i) => (
                                                <DesktopOrderListItem key={['_', i].join('')} classes={classes} orderNumber={orderNumber} index={i} uuid={uuid} items={data} hasOrderSpecific={hasOrderSpecific} userProfile={userProfile} />
                                            ))
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    )
                    : (
                        <Grid container>
                            <Grid item xs={12}>
                                {
                                    items.map((data, i) => (
                                        <DesktopOrderListItem key={['_', i].join('')} classes={classes} orderNumber={orderNumber} index={i} uuid={uuid} items={data} hasOrderSpecific={hasOrderSpecific} userProfile={userProfile} brand={brand} />
                                    ))
                                }
                            </Grid>
                        </Grid>
                    )}
            </div>
        );
    }
}

DesktopOrderList.propTypes = {
    classes: object.isRequired,
    order: shape({
        orderNumber: string,
        intOrderNumber: string,
        orderPlaceddate: string,
        customerFirstName: string,
        customerLastName: string,
        modifyOrder: string,
        parentOrderNumber: string,
        uuid: string,
        items: arrayOf(
            shape({
                brandId: string,
                productSku: string,
                productName: string,
                recpFirstName: string,
                recpLastName: string,
                shipDate: string,
                paymentStatus: string,
                estimatedDeliveryDate: string,
                trackingNumber: string,
                itemType: string,
                sfItemType: string,
                addonType: string,
                parentLineNumber: string,
                childLineNumber: string,
                flexDate: string,
                flexMessage: string,
                flexGuaranteedFlag: string,
                prdImgCtg: string,
                prdImgTmn: string,
                arrivalStartDate: string,
                arrivalEndDate: string,
                carrier: string,
                seoUrl: string,
                subscriptionType: string,
                interval: string,
                duration: string,
            }),
        ),
    }).isRequired,
    userProfile: shape({
        isAuthenticated: bool.isRequired,
    }).isRequired,
    brand: object.isRequired,
};

export default withStyles(styles)(DesktopOrderList);
